import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';
import { FloatingUploadManager } from '@/components/data-upload/FloatingUploadManager';
import { TilesetProcessingWatcher } from '@/components/data-upload/TilesetProcessingWatcher';
import { Footer } from '@/components/footer';
import { Header } from '@/components/header';
import { AppContextProvider } from './context/AppContext';
import { FileUploadActivityProvider } from './context/FileUploadActivityContext';
import { useKeycloak } from './context/KeycloakContext';
import { MobileAssetTabProvider } from './context/MobileAssetTabContext';
import { TilesetUploadProvider } from './context/TilesetUploadContext';

export function MainLayout() {
	const { t } = useTranslation();
	const { initialized } = useKeycloak();
	const location = useLocation();
	// Adjust these paths if your root asset route is different
	const isHomeRoute = location.pathname === '/v1' || location.pathname === '/';

	return (
		<AppContextProvider>
			<MobileAssetTabProvider>
				<TilesetUploadProvider>
					<FileUploadActivityProvider>
						{!initialized && (
							<div className="flex h-screen w-full items-center justify-center bg-background">
								<div className="flex flex-col items-center gap-3">
									<div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
									<p className="text-sm font-medium text-foreground">{t('common.app.initializing')}</p>
								</div>
							</div>
						)}
						{initialized && (
							<div className="min-h-screen bg-background font-sans text-primary flex flex-col">
								<div className="flex-1 flex flex-col h-screen overflow-hidden">
									{!isHomeRoute && <Header />}
									<Outlet />
									<Footer />
								</div>
							</div>
						)}
						<FloatingUploadManager />
						<TilesetProcessingWatcher />
					</FileUploadActivityProvider>
				</TilesetUploadProvider>
			</MobileAssetTabProvider>
		</AppContextProvider>
	);
}
